export default __webpack_public_path__ + "static/media/phone_dark.f34d65ea.png";